import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";

import { Session } from "./types";
import { logout, whoami } from "./lib/auth";
import LoginForm from "./components/LoginForm";
import MaterialIcon from "./components/MaterialIcon";
import Header from "./components/Header";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

function RootComponent() {
  let [loading, setLoading] = useState<boolean>(true);
  let [session, setSession] = useState<Session | null>(null);

  // Check if logged in on load
  useEffect(() => {
    console.log("Checking for existing login");
    let f = async () => {
      let data = await whoami();
      if (data.logged_in) {
        setSession({
          user: data.username,
          user_id: data.user_id,
        });
      }
      setLoading(false);
    };

    f();
  }, []);

  async function handleLogout() {
    await logout();
    setSession(null);
  }

  function handleLogin(session: Session) {
    setSession(session);
  }

  return (
    <div className="bg-grayscale-900 h-screen w-screen font-sans font-light">
      {!loading ? (
        <>
          {session !== null ? (
            <App session={session} handleLogout={handleLogout} />
          ) : (
            <>
              <Header session={session} handleLogout={handleLogout} />
              <main className="flex items-center justify-center pt-20">
                <LoginForm callback={handleLogin} />
              </main>
            </>
          )}
        </>
      ) : (
        <div className="flex h-screen w-screen items-center justify-center">
          <MaterialIcon icon="progress_activity" className="animate-spin" />
        </div>
      )}
    </div>
  );
}

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
